import { NgModule } from '@angular/core';
import { NotificationModalComponent } from './shared/components/notification-modal/notification-modal.component';
import { SharedModule } from '@shared/shared.module';

@NgModule({
  declarations: [NotificationModalComponent],
  imports: [SharedModule],
})
export class NotificationsModule {}
